import { render, staticRenderFns } from "./manage-alert.vue?vue&type=template&id=f1a6cfd8&scoped=true"
import script from "./manage-alert.vue?vue&type=script&lang=js"
export * from "./manage-alert.vue?vue&type=script&lang=js"
import style0 from "./manage-alert.vue?vue&type=style&index=0&id=f1a6cfd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a6cfd8",
  null
  
)

export default component.exports